import Slider from 'rc-slider';
import { useEffect, useState } from 'react';

export type FormSliderProps = {
    label: string;
    suffix: string;
    min: number;
    max: number;
    value: number | null;
    step?: number;
    onChange: (value: number) => void;
    formatNumber: (n: number) => string;
    handleSize?: number;
    trackColor?: string;
};

export const FormSlider = ({
    handleSize = 32,
    min = 1,
    max = 10,
    value = 5,
    step = 1,
    onChange,
    trackColor = '#117069',
    label,
    suffix,
    formatNumber,
}: FormSliderProps) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const handleSizeAndPositioning = (preferredDiameter: number) => {
        const marginTop = (preferredDiameter / 2 - 2) * -1;
        return {
            width: preferredDiameter,
            height: preferredDiameter,
            marginTop,
        };
    };

    const handleStyle = {
        ...handleSizeAndPositioning(handleSize),
        backgroundColor: 'white',
        border: 'none',
        filter: 'drop-shadow(0px 2px 8px rgba(52, 58, 64, 0.20))',
        opacity: 1,
    };

    const trackStyle = {
        backgroundColor: trackColor,
    };

    const railStyle = {
        backgroundColor: '#ADB5BD',
    };

    return (
        isClient && (
            <Slider
                ariaLabelForHandle={label}
                ariaValueTextFormatterForHandle={val => `${formatNumber(val)} ${suffix}`}
                min={min}
                max={max}
                value={value || 0}
                step={step}
                styles={{
                    handle: handleStyle,
                    track: trackStyle,
                    rail: railStyle,
                }}
                onChange={val => {
                    if (typeof val === 'number') {
                        onChange(val);
                    }
                }}
            />
        )
    );
};
